<script setup>
import { RouterView } from 'vue-router'
import { ref, onMounted } from 'vue'
// const { RouterView } = window.VueRouter
// const { ref, onMounted } = window.Vue

onMounted(() => {
  document.addEventListener(
    'touchstart',
    function (event) {
      if (event.touches.length > 1) {
        event.preventDefault()
      }
    },
    { passive: false }
  )
})
</script>

<template>
  <div class="w-full max-w-[1400px] mx-auto">
    <RouterView />
  </div>
</template>

<style scoped></style>
